import {
  Paper,
  Typography,
  makeStyles,
  Box,
  Container,
  Button,
  Chip
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import Page from 'src/components/Page';
import CustomDataTable from '../../components/Table/CustomDataTable';
import { getReqHistoryAction } from '../../store/actions/ReqHistoryActions';
import FilterRequestHistory from './components/FilterRequestHistory';
import { convertDateToUnix, getLastNDays } from 'src/utils/utils';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(3),
    textAlign: 'center'
  },
  paperTable: {
    backgroundColor: theme.palette.background.paper,
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    marginTop: theme.spacing(2),
    textAlign: 'right'
  },
  otherInfo: {
    display: 'flex',
    justifyContent: 'center',
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1)
  },
  datatable: {
    marginTop: theme.spacing(2)
  },
  box: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  userActions: {
    marginTop: theme.spacing(2)
  },
  table: {
    minWidth: 750
    // minHeight: 500
  },
  actionBtn: {
    marginRight: theme.spacing(1)
  }
}));

function RequestHistory() {
  const classes = useStyles();
  const profile = JSON.parse(sessionStorage.getItem('profile'));
  const dispatch = useDispatch();
  const reqHistoryList = useSelector((state) => state.ReqHistory.reqHistory);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    async function callReqHistory() {
      const filterObj = {
        fromDate: convertDateToUnix(getLastNDays(30)),
        toDate: convertDateToUnix(getLastNDays(0))
      };
      const response = await dispatch(getReqHistoryAction(filterObj, profile));
      if (response) {
        setLoading(false);
      }
    }
    callReqHistory();
  }, []);

  const tableConfig = [
    {
      title: 'S/N',
      value: 'sn',
      align: 'center',
      render: (row, i) => <> {i + 1} </>
    },
    {
      title: 'UserID',
      value: 'userID',
      align: 'center'
    },

    {
      title: 'Route',
      value: 'route',
      align: 'center'
    },
    {
      title: 'Response Message',
      value: 'response',
      align: 'center',
      render: (row) => {
        let parsedResponse;
        try {
          if (row.response) parsedResponse = JSON.parse(row.response).message;

          return (
            <Chip
              variant="outlined"
              color="primary"
              size="small"
              label={parsedResponse}
            />
          );
        } catch (error) {
          console.log('Error: <RequestHistory /> ', error);
          return '';
        }
      }
    },
    {
      title: 'Cost',
      value: 'cost',
      align: 'center'
    },
    {
      title: 'Client Name',
      value: 'issuer',
      align: 'center',
      render: (row) => row?.issuer?.fullname
    },
    {
      title: 'Status',
      value: 'status',
      align: 'center',
      render: (row, i) =>
        row.status == 0 ? (
          <Chip
            variant="outlined"
            color="primary"
            size="small"
            label="Deactivated"
          />
        ) : (
          <Chip
            style={{ background: 'green', color: 'white' }}
            size="small"
            label="Active"
          />
        )
    },
    {
      title: 'Transaction Date',
      value: 'transDate',
      align: 'center',
      render: (row) => moment(row.transDate * 1000).format('DD/MM/YYYY hh:mm a')
    }
  ];

  return (
    <Page className={classes.root} title="API Request History">
      <Container maxWidth="lg">
        <Box>
          <FilterRequestHistory />
        </Box>
        <Box className={classes.datatable}>
          <CustomDataTable
            tableData={reqHistoryList}
            tableConfig={tableConfig}
            loading={loading}
            filterField="route"
          />
        </Box>
      </Container>
    </Page>
  );
}

export default RequestHistory;
